import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { PackageList } from './PackageList';
import { PackageEditor } from './PackageEditor';
import { ROUTES } from '@/routes';

/**
 * Mode router for the Assessment Packages admin surface: the list lives at
 * ADMIN_PACKAGES, and the same full-page editor is reused for both
 * ADMIN_PACKAGE_NEW (no :id) and ADMIN_PACKAGE_EDIT (:id present) — mirrors
 * the AdminQuestionSets routing pattern.
 */
export const AdminPackages: React.FC = () => {
  const { id } = useParams<{ id?: string }>();
  const location = useLocation();
  const isNew = location.pathname === ROUTES.ADMIN_PACKAGE_NEW;

  if (isNew) return <PackageEditor />;
  if (id) return <PackageEditor id={id} />;
  return <PackageList />;
};

export default AdminPackages;
